import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { HelpGuideNotifier } from './help-guide-notifier';
import { HelpGuideState } from './help-guide-state';

@Injectable()
export class HelpGuideProvider extends BaseProvider<HelpGuideNotifier, HelpGuideState> {
  constructor() {
    super(HelpGuideNotifier);
  }
}
